module.exports = __webpack_public_path__ + "assets/images/three_edd980a1096db8097ac5eaa3e79ea079.png";